// Hooks
import { useDesktopLogic } from './useDesktopLogic';
import { useMobileLogic } from './useMobileLogic';

export const useMarketingBlurb = (isDesktop = false) => {
  const marketingBlurbLogic = isDesktop ? useDesktopLogic : useMobileLogic;

  return marketingBlurbLogic();
};
